import { ContactUsDetails } from "src/app/components/about/service/models/ContactUs.model";
import { AssetDTO, lecturersDto, speakersDto } from "src/app/shared/models/models";

export class CouresespageContentDetails{
  courseTitle:string = '';
  aboutCourse:string = '';
  coverImage:AssetDTO = new AssetDTO();
  startDate:string = '';
  endDate:string = '';
  locationName:string = '';
  contacts:speakersDto = new speakersDto();
  lecturers:lecturersDto = new lecturersDto();
}


export class items {
  id:string = '';

  flatData:CouresespageContentDetails = new CouresespageContentDetails();

} 

export class CouresespageContentModel {
  total:number = 0;
  items:items = new items();
  
}